var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.335V.668L4.665 4.001l3.333 3.334V4.668c2.207 0 4 1.793 4 4s-1.793 4-4 4c-2.206 0-4-1.793-4-4H2.666a5.332 5.332 0 0 0 5.333 5.333 5.332 5.332 0 0 0 5.334-5.333 5.332 5.332 0 0 0-5.334-5.333z"
})));
export default SvgReplay;